import API from '../../../../axios'
import { actions, setTrainerDialogSettingsVisibility } from '../../../slices/trainerSettings'
import { actions as dashdoardActions } from '../../../slices/userDashboard'
import { getAllPlayers, getLib, getSpotName, trainerPositions } from '../../../../Trainer/utils/helpers'
import { setStartedConfigurationName } from '../../../slices/trainer'

const defaultJsonSort = { name: '', order: '' }

export const setConfigurationsData =
	(json_sort = defaultJsonSort, offset, limit, isRename = false, customPayload = null, isDashboard = false) =>
	(dispatch, getState) => {
		const {
			sessionFilters: { name, spotId, is_manual },
			configurationId,
			isReady,
		} = getState().trainerSettings

		const payload = {
			name,
			is_manual: customPayload ? customPayload.isManual : is_manual,
			spot_id: customPayload ? customPayload.spots : spotId === null ? [] : spotId,
			limit: limit,
			offset: offset,
		}

		if (isDashboard) {
			dispatch(dashdoardActions.setIsLoadingConfigs(true))
		} else {
			dispatch(actions.setIsLoadingConfig(true))
		}

		API.post('get_trainer_configurations', { json_filter: payload, json_sort: json_sort })
			.then(({ data }) => {
				if (customPayload) {
					dispatch(dashdoardActions.setLastConfiguration({ [customPayload.lib]: data.configurations }))
				} else {
					dispatch(
						actions.setConfigurationsData({
							presets: data.configurations,
							total: data.total,
							unfilteredTotalPresets: data.unfiltered_total,
						})
					)
				}

				const selectedConfig = isReady && data.configurations.find((el) => el.id === configurationId)

				if (configurationId && selectedConfig) {
					const settings = selectedConfig.settings
					const librariesResponse = getState().libs.librariesResponse
					const playersArray = trainerPositions(librariesResponse)
					const allPlayers = getAllPlayers(settings.spotId, librariesResponse)
					const [spotName] = getSpotName(librariesResponse?.libraries, settings.spotId, playersArray)
					const gameLibrary = getLib(settings.spotId, librariesResponse)

					dispatch(setStartedConfigurationName(selectedConfig.name))

					dispatch(
						actions.setSavedConfigurationToStartTrain({
							settings,
							allPlayers,
							gameLibrary,
							spotName,
						})
					)

					if (isReady && !isRename) {
						dispatch(setTrainerDialogSettingsVisibility(false))
					}
				}

				if (isDashboard) {
					dispatch(dashdoardActions.setIsLoadingConfigs(false))
				} else {
					dispatch(actions.setIsLoadingConfig(false))
				}
			})
			.catch((e) => {
				if (isDashboard) {
					dispatch(dashdoardActions.setIsLoadingConfigs(false))
				} else {
					dispatch(actions.setIsLoadingConfig(false))
				}
				console.log('error', e)
			})
	}
